var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPrev(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.62654 4.71535C1.17816 4.93108 1.17816 5.56957 1.62654 5.7853L8.74294 9.20918C9.13708 9.39881 9.594 9.11159 9.594 8.6742V1.82645C9.594 1.38906 9.13708 1.10184 8.74294 1.29147L1.62654 4.71535Z",
    fill: "white",
    stroke: "#A1A1A1",
    strokeWidth: 1.31249
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrev);
export default __webpack_public_path__ + "static/media/prev.0fb7b8975ca9f4cb4787a1cce146b898.svg";
export { ForwardRef as ReactComponent };